// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_hc","advertDetailParameterList__header":"c-n_he","advertDetailParameterList__list":"c-n_hf"};